import React from "react";
import { Card, Form } from "antd";
import { Tiles } from "@cloudscape-design/components";

const StepOne: React.FC<{ sectionType: string, setSectionType: (sectionType: any) => void }> = ({ sectionType, setSectionType }) => {



    return (
        <Card style={{ marginTop: "35px" }}>
            <Form.Item>
                <Tiles
                    onChange={({ detail }) => setSectionType(detail.value)}
                    value={sectionType}
                    items={[
                        {
                            label: "Provider",
                            value: "Provider",
                            description: "Section for individual provider-specific fields(e.g., licenses, credentials)."
                        },
                        {
                            label: "Facility",
                            value: "Facility",
                            description: "Section for individual facility-specific fields(e.g., location, type, accrediation)."
                        }
                    ]}
                />
            </Form.Item>
        </Card>
    );
};

export default StepOne;
